import React, { Component } from 'react';
import moment from 'moment';
import { isEmpty } from 'lodash/lang';
import { isAllDayEvent } from '../helpers/util';
import { withTranslation } from 'react-i18next';
class EventDurationBooked extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { t } = this.props
        const { event } = this.props;
        const startTime = moment(event.start);
        const endTime = moment(event.end);
        if (isEmpty(event)) {
            return null;
        }
        const isAllDay = isAllDayEvent(event)
        return (
            <div style={{fontSize:35}}>
                {isAllDay ?
                    t('EventDurationBooked.AllDay') :
                    `${startTime.format("H:mm")} - ${endTime.format("H:mm")}`
                }
            </div>
        );
    }
}

export default withTranslation()(EventDurationBooked)
